import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <nav
      data-testid="hexis-nav"
      className="glass"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 32px",
      }}
    >
      <Link
        to={user ? "/laboratory" : "/"}
        data-testid="nav-home-link"
        style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", gap: 14 }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" className="hexmotif" style={{ color: "var(--brass)" }}>
          <polygon
            points="16,2 28,9 28,23 16,30 4,23 4,9"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <polygon
            points="16,8 24,12 24,20 16,24 8,20 8,12"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.7"
            opacity="0.6"
          />
          <circle cx="16" cy="16" r="2" fill="currentColor" />
        </svg>
        <div style={{ lineHeight: 1 }}>
          <div className="font-serif" style={{ fontSize: 22, color: "var(--parchment)" }}>HEXIS OS</div>
          <div className="overline" style={{ fontSize: 9, marginTop: 3 }}>Meta-Architect</div>
        </div>
      </Link>

      <div style={{ display: "flex", alignItems: "center", gap: 28 }}>
        {user ? (
          <>
            <Link
              data-testid="nav-laboratory-link"
              to="/laboratory"
              className="font-mono"
              style={{ color: "var(--parchment-dim)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", textDecoration: "none" }}
            >
              Laboratory
            </Link>
            <Link
              data-testid="nav-history-link"
              to="/sprints"
              className="font-mono"
              style={{ color: "var(--parchment-dim)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", textDecoration: "none" }}
            >
              Sprints
            </Link>
            <Link
              data-testid="nav-leaderboard-link"
              to="/leaderboard"
              className="font-mono"
              style={{ color: "var(--parchment-dim)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", textDecoration: "none" }}
            >
              Leaderboard
            </Link>
            <Link
              data-testid="nav-settings-link"
              to="/settings"
              className="font-mono"
              style={{ color: "var(--parchment-dim)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", textDecoration: "none" }}
            >
              Settings
            </Link>
            <div className="font-display" style={{ color: "var(--parchment-dim)", fontSize: 14 }}>
              {user.name?.split(" ")[0] || user.email}
            </div>
            <button
              data-testid="nav-logout-btn"
              className="btn-ghost"
              onClick={async () => { await logout(); nav("/"); }}
            >
              Logout
            </button>
          </>
        ) : (
          <Link to="/auth" data-testid="nav-enter-lyceum-btn" className="btn-brass">
            Enter the Lyceum
          </Link>
        )}
      </div>
    </nav>
  );
}
